import Footer from "../components/footer/en/Footer";
import Header from "../components/header/en/Header";
import Details from "../components/pages/notice/en/Details";

const NoticeDetail = () => {   
    return (
        <>
            <Header />
            <Details />
            <Footer />
        </>
    );
}
export default NoticeDetail;